import { Container, Input, Label } from "./styles";

export default function AnswerFileUpload({
  answerFileUrl,
  onNewFile = () => null,
  onChangeFile = () => null,
}) {
  const handleChangeFile = (e) => {
    const file = e.target.files[0];

    if (!file) {
      return;
    }

    onChangeFile(file);
  };

  return (
    <Container>
      <Label>
        <span>Gabarito detalhado (Opcional)</span>
        {!answerFileUrl && <Input type="file" onChange={handleChangeFile} />}
        {answerFileUrl && (
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <a
              href={answerFileUrl}
              target="_blank"
              style={{
                maxWidth: "30rem",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {answerFileUrl}
            </a>
            <button style={{ cursor: 'pointer' }} onClick={onNewFile}>Selecionar novo arquivo</button>
          </div>
        )}
      </Label>
    </Container>
  );
}
